import React from "react";

const Layout = ({ children }) => {
  return (
    <div className="relative min-h-[calc(100vh-3.5rem)] w-full">
      <div className="relative mx-auto w-full max-w-7xl px-4 pb-12 pt-6 sm:px-6 lg:px-8">
        {children}
      </div>
    </div>
  );
};

export default Layout;
